const EditFriendAddyDialog4i = function(){ 
	const forms = new forms4i();
	const common = new bbCommon();
	const friendAddressDialog = new Dialog4i();
	const bbModel = common.bbModel;
	const errorHTML = 
		'<p class="text16 marginBtm10" role="alert" aria-atomic="true">Oops! There was an error getting your form. Please close this dialog and try again. If this continues, please <a href="/info/contactus">contact us</a>.</p>';
	const loadingIcon = 
		'<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading address dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
	
	let firstNameInput, lastNameInput, companyInput, cityInput, stateInput, 
		zipCodeInput, addressInput1, addressInput2, addressInput3, msgInput, shareBoxID;
	
	const init = () => {
		friendAddressDialog.Init({
			triggerElements: document.getElementById("yesFriendBox"),
			dialogClass: "mediumDialog", 
			title: "Delivery Address",
			content: loadingIcon, 
			onOpen: updateContent
		});   
	};

	const updateContent = async () => {
		try {
      			const response = await fetch('/bluebox/GetEditFriendAddress', { method: 'GET' });

      			//if (!response.ok) throw new Error('Error fetching friend address data');

      			const dialog = document.getElementById("popUpDialog");
      			const responseText = await response.text();
      			dialog.querySelector(".dialogContent").innerHTML = responseText;
     			initFormVariables();
      			dialog.addEventListener("click", friendEvents);
    		} catch (error) {
      			const dialog = document.getElementById("popUpDialog");
      			dialog.querySelector(".dialogContent").innerHTML = errorHTML;
      			console.log(error);
    		}
	};
	
	const friendEvents = (e) => {
		if(e.target.id == "acceptFriendBox"){
			e.preventDefault();
			const friendAddressForm = document.getElementById("editFriendAddress");
			forms.formValidation(friendAddressForm, acceptFriendBox, e);
		}else if(e.target.id == "cancelFriendBox"){
			e.preventDefault();
			friendAddressDialog.Close();
		}
	};
	
	const initFormVariables = () => {
		firstNameInput = document.getElementById("FriendFirstName");
		lastNameInput = document.getElementById("FriendLastName");
		companyInput = document.getElementById("FriendCompany");
		cityInput = document.getElementById("FriendCity");
		stateInput = document.getElementById("FriendState");
		zipCodeInput = document.getElementById("FriendZipcode");
		addressInput1 = document.getElementById("FriendAddress1");
		addressInput2 = document.getElementById("FriendAddress2");
		addressInput3 = document.getElementById("FriendAddress3");
		msgInput = document.getElementById("FriendMessage");
		shareBoxID = document.getElementById("ShareableBoxID"); 
	};

	const acceptFriendBox = async () => {
		document.getElementById("acceptFriendBoxLoad").classList.remove("hide");
		common.DisableBlueBtn(document.getElementById("acceptFriendBox"));
		common.RemoveStatusMsg();

		bbModel.FriendFirstName = firstNameInput ? firstNameInput.value : "";
           	bbModel.FriendLastName = lastNameInput ? lastNameInput.value : "";
		bbModel.FriendCompany = companyInput ? companyInput.value : "";
           	bbModel.FriendCity = cityInput ? cityInput.value : "";
       	bbModel.FriendState = stateInput ? stateInput.value : "";
         	bbModel.FriendZipCode = zipCodeInput ? zipCodeInput.value : "";
          	bbModel.FriendAddress1 = addressInput1 ? addressInput1.value : "";
		bbModel.FriendAddress2 = addressInput2 ? addressInput2.value : "";
		bbModel.FriendAddress3 = addressInput3 ? addressInput3.value : "";
		bbModel.FriendMessage = msgInput ? msgInput.value : "";
		bbModel.ShareableBoxID = shareBoxID ? shareBoxID.value : "";

		common.FixBoxModel(bbModel);
		let responseJSON;
		try {
      			const response = await fetch('/bluebox/AcceptFriendBox', {
        			method: 'POST',
        			credentials: 'same-origin',
        			body: JSON.stringify(bbModel),
        			headers: {
          				'Content-Type': 'application/json',
          				'X-Requested-With': 'fetch',
          				'RequestVerificationToken': common.HeaderToken,
          				'__RequestVerificationToken': common.HeaderToken
        			}
      			});

      			//if (!response.ok) throw new Error('Error processing accept friend box request');
			responseJSON = await response.json();
    		} catch (error) {
      			friendBoxError();
			console.log(error);
    		}
    		
    		if(responseJSON) friendBoxSuccess(responseJSON);
	};
	
	const friendBoxError = () =>{
		friendAddressDialog.Close();
      		common.DisplayStatusMsg();
	};
	
	const friendBoxSuccess = (response) => {
		addFriendAddressDisplay();
		common.DisplayFormSections(response);
		friendAddressDialog.Close();
		if (response.friendBox) {
			document.getElementsByClassName("errorMsg1")[0].classList.add("hide");
			document.getElementsByClassName("errorMsg5")[0].classList.remove("hide");
		}
	};
	
	const showInfo = (displayItem, modelItem) => {
		if (displayItem) {
			if (modelItem.trim() == "") displayItem.classList.add("hide");
			else displayItem.innerHTML = modelItem;
		}
	};
	
	const addFriendAddressDisplay = () => {
		const friendName = bbModel.FriendFirstName + " " + bbModel.FriendLastName;
		const friendNameDisplay = document.getElementById("resultFriendName");
		showInfo(friendNameDisplay, friendName);
		//if (friendNameDisplay && friendName.trim() != "") friendNameDisplay.innerHTML = friendName;
		
		const friendCompanyDisplay = document.getElementById("resultFriendCompany");
		showInfo(friendCompanyDisplay, bbModel.FriendCompany);
		
		const friendAddr1Display = document.getElementById("resultFriendAddr1");
		showInfo(friendAddr1Display, bbModel.FriendAddress1);
		//if (friendAddr1Display && bbModel.FriendAddress1.trim() != "") friendAddr1Display.innerHTML = bbModel.FriendAddress1;
		
		const friendAddr2Display = document.getElementById("resultFriendAddr2");
		showInfo(friendAddr2Display, bbModel.FriendAddress2);
		
		const friendAddr3Display = document.getElementById("resultFriendAddr3");
		showInfo(friendAddr3Display, bbModel.FriendAddress3);
		
		const friendCityDisplay = document.getElementById("resultFriendCity");
		showInfo(friendCityDisplay, bbModel.FriendCity);
		//if (friendCityDisplay && bbModel.FriendCity.trim() != "") friendCityDisplay.innerHTML = bbModel.FriendCity;
		
		const friendStateDisplay = document.getElementById("resultFriendState");
		showInfo(friendStateDisplay, bbModel.FriendState);
		
		const friendZipcodeDisplay = document.getElementById("resultFriendZipcode");
		showInfo(friendZipcodeDisplay, bbModel.FriendZipCode);
		//if (friendZipcodeDisplay && bbModel.FriendZipCode .trim() != "") friendZipcodeDisplay.innerHTML = bbModel.FriendZipCode ;
		
		const friendMessageDisplay = document.getElementById("resultFriendMessage");
		const friendMessageContainer = document.getElementById("resultFriendMessageContainer");
		if (friendMessageDisplay && bbModel.FriendMessage.trim() != "") {
			friendMessageDisplay.innerHTML = bbModel.FriendMessage;
			friendMessageContainer.classList.remove("hide");
		}
		
		const friendAddressDisplay = document.getElementById("resultFriendAddressInfo");
		friendAddressDisplay.classList.remove("hide");
	};

	return{
		Init: init
	};
};